import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { User } from 'src/app/core/types/user.interface';
import { userIsReviewPublisher } from 'src/app/shared/helpers/user-is-review-publisher';

import { ErrorMessages } from '../types/error-messages.enum';
import { AuthService } from './../services/auth.service';
import { IUser, userIsAdmin } from '@solomonicuk/core-sdk';

@Injectable({
  providedIn: 'root',
})
export class EntitiesAllowedRolesGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    try {
      const user = await this.authService.getDecodedToken<IUser>();
      // this could be expanded to allow for easier adding of roles
      if (!(userIsReviewPublisher(user) || userIsAdmin(user))) {
        throw new Error(ErrorMessages.IncorrectUserRole);
      }
      return true;
    } catch (e) {
      this.router.navigateByUrl('/login');
      return false;
    }
  }
}
